export default __webpack_public_path__ + "static/media/family_medical_history.4a4e5303.png";